/**
 * Getters for appointment details
 */
export const getters = {
  getDetail(state) {
    return state.details;
  },
  getQueriedId(state) {
    return state.idQueried;
  },
  getDeletedAppointment(state) {
    return state.deleted;
  },
  getChangeToEdit(state) {
    return state.changeToEdit;
  },
  getLoadingAppointmentDetails(state) {
    return state.loadingAppointmentDetails;
  }
};
